import useTailwindConfig from '../hooks/useTailwindConfig';

const ThemeHex = (themeColor: string) => {
  const { colors } = useTailwindConfig().theme;
  return colors[`${themeColor}`];
};

export default ThemeHex;
